// GET /accounts with no :accountId → bounce to the last-used account's overview,
// in THIS workspace, or to /pipeline if nothing's remembered. Mirrors the IG Field Suite's
// LegacyModuleRedirect pattern.
import { Navigate } from "react-router-dom";
import { lastAccountId } from "@/state/account";
import { useAuth } from "@/state/auth";

export function AccountRootRedirect() {
  const ws = useAuth().activeAgency?.id;
  const last = lastAccountId(ws);
  if (last) return <Navigate to={`/accounts/${last}/overview`} replace />;
  return <Navigate to="/pipeline" replace />;
}
